import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthCheckService } from 'app/modules/utils/auth-check.service'; 

export const AuthCookieInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  // Get the service using inject (functional DI)
  const authCheckService = inject(AuthCheckService);
  
  // Skip auth check for some endpoints
  if (isExemptUrl(req.url)) {
    return next(req);
  }
  
  // Check auth requirements
  if (!authCheckService.checkAuthRequirements()) {
    // Handle unauthorized access
    authCheckService.handleUnauthorized();
    return throwError(() => new Error('Authentication data missing'));
  }
  
  return next(req).pipe(
    catchError(error => {
      // If the error is authentication-related (401/403), check auth again
      if (error.status === 401 || error.status === 403) {
        authCheckService.checkAuthRequirements();
      }
      return throwError(() => error);
    })
  );
};

// Helper function to check exempt URLs
function isExemptUrl(url: string): boolean {
  const exemptUrls = [
    '/auth/login',
    '/auth/activate',
    '/auth/remember',
    '/auth/rememberPassword',
    '/auth/signup',
    '/home',
    '/'
    // Add other exempt URLs that don't require auth
  ];
  
  return exemptUrls.some(exempt => url.includes(exempt));
}